module.exports = __webpack_public_path__ + "img/symbol_7.d4cdee93.png";